<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <page-header :title="$t('coefficientReliabilityReport')">
      <template slot="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="cyan darken-1"
              dark
              @click="refreshCoefficientReliability()"
              v-on="on"
            >
              {{ $t("refreshCoefficient") }}
            </v-btn>
          </template>
          <span>{{ $t("refreshCoefficientReliabilityTooltip") }}</span>
        </v-tooltip>
      </template>
    </page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn flat icon @click="filter.year--">
                  <v-icon>arrow_left</v-icon>
                </v-btn>
                <v-text-field
                  prepend-icon="date_range"
                  :label="$t('year')"
                  type="number"
                  v-model="filter.year"
                  :single-line="true"
                ></v-text-field>
                <v-btn flat icon @click="filter.year++">
                  <v-icon>arrow_right</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="coefficientReliability"
                :loading="coefficientReliabilityIsLoading"
                class="elevation-1"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ getFleetName(props.item.fleet) }}</td>
                  <td>{{ props.item.quarter }}</td>
                  <td>{{ props.item.inaccessibility_in_hours }}</td>
                  <td>{{ props.item.vehicle_reliability | percent }}</td>
                  <td>{{ props.item.updated_at | moment("LLL") }}</td>        
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  FETCH_COEFFICIENT_RELIABILITY,
  UPDATE_COEFFICIENT_RELIABILITY,
  FETCH_FLEETS,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        year: new Date().getFullYear()
      },
      headers: [
      { text: this.$t("fleet"), value: "fleet" },
        { text: this.$t("quarter"), value: "quarter" },
        {
          text: this.$t("inaccessibilityInHours"),
          value: "inaccessibility_in_hours"
        },
        { text: this.$t("vehicleReliability"), value: "vehicle_reliability" },
        { text: this.$t("lastUpdated"), value: "updated_at" }
      ]
    };
  },
  computed: {
    ...mapGetters(["coefficientReliability", "coefficientReliabilityIsLoading", "fleets", "fleetsCount", "fleetIsLoading"]),
    mappedCoefficientReliability() {
      return this.coefficientReliability.map(item => ({
        ...item,
        fleet: this.getFleetName(item.fleet)
      }));
    }
  },
  mixins: [refreshButtonMixin],
  watch: {
    filter: {
      handler: function() {
        this.fetchItems();
      },
      deep: true
    }
  },
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_COEFFICIENT_RELIABILITY, this.filter.year);
      this.$store.dispatch(FETCH_FLEETS, [0, 0]);
    },
    refreshCoefficientReliability() {
      this.$store.dispatch(UPDATE_COEFFICIENT_RELIABILITY).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("refreshCoefficientReliabilitySuccessfully"),
          color: "success"
        });

        this.fetchItems();
      });
    },
    getFleetName(fleetId) {
      
      // Jeśli fleet.id jest równe 0, zwróć wartość ze słownika 'fleet0'
        if (fleetId === 0) {
          return this.$t('fleet0');
        }
        
      // Znajdź flotę na podstawie przekazanego fleetId
      const fleet = this.fleets.find(fleet => fleet.id === fleetId);
      
      // Sprawdź, czy flota została znaleziona
      if (fleet) {
        // W przeciwnym razie zwróć nazwę floty
        return fleet.name;
      }
      
      // Jeśli flota nie została znaleziona, zwróć wartość ze słownika 'unknownFleet'
      return this.$t('unknownFleet');
  }

  },
  created() {
    this.fetchItems();
  }
};
</script>

<style scoped></style>
